// istanbul ignore file
export const getReservationAmount = () => 0;
export const isReservationComplete = () => false;
